import { Trans } from 'react-i18next'

import Author from 'js/components/Item/ItemHeader/components/Author'
import Date from 'js/components/Item/ItemHeader/components/Date'
import Source from 'js/components/Item/ItemHeader/components/Source'
import Views from 'js/components/Item/ItemHeader/components/Views'
import Wrapper from 'js/components/Item/ItemHeader/components/Wrapper'
import Text from 'js/components/Text/Text'
import { useSiteStore } from 'js/lib/stores'

type Entity = {
    views?: number
    owner?: any
    source?: string
    timePublished?: string
    isLocked?: boolean
    showOwner?: boolean
    [key: string]: any
}

type Options = {
    author?: boolean
    publishDate?: boolean
    views?: boolean
}

type Props = {
    site?: any
    viewer?: {
        loggedIn?: boolean
        user?: {
            guid?: string
        }
    }
    entity: Entity
    onEdit: any
    onAfterDelete: any
    refetchQueries?: string[]
    options?: Options
    hasCustomTheme?: boolean
}

const ItemHeader = ({
    site,
    viewer,
    entity,
    options = {
        author: true,
        publishDate: true,
        views: true,
    },
}: Props) => {
    const showViewsCount = useSiteStore(({ site }) => site.showViewsCount)
    const { views, owner, source, timePublished, isLocked, showOwner } = entity

    const showPublishDate = options.publishDate
    const showAuthor = options.author && showOwner && owner
    const showViews = options.views && showViewsCount && Number.isFinite(views)

    const showLockedMessage =
        isLocked && viewer?.loggedIn && owner?.guid === viewer?.user?.guid

    if (
        !showPublishDate &&
        !showAuthor &&
        !showViews &&
        !source &&
        !showLockedMessage
    ) {
        return null
    }

    return (
        <header
            style={{
                marginTop: '32px',
            }}
        >
            <Wrapper style={{ minHeight: '32px' }}>
                <div className="Meta">
                    {!showAuthor && showPublishDate && (
                        <Date timePublished={timePublished} />
                    )}
                    {source && <Source>{source}</Source>}
                    {showViews && <Views>{views}</Views>}
                </div>
                {showAuthor && (
                    <Author
                        entity={entity}
                        showPublishDate={options.publishDate}
                        className="Author"
                    />
                )}
            </Wrapper>

            {showLockedMessage && (
                <Text
                    size="small"
                    variant="grey"
                    textAlign="center"
                    style={{ marginBottom: '16px' }}
                >
                    <Trans i18nKey="entity-question.is-locked">
                        This question is locked because it has answers already.
                        {site?.questionLockAfterActivityLink ? (
                            <a
                                href={site.questionLockAfterActivityLink}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Contact an administrator
                            </a>
                        ) : (
                            <span>Contact an administrator</span>
                        )}
                        if you want to make changes.
                    </Trans>
                </Text>
            )}
        </header>
    )
}

export default ItemHeader
